import { script, isWeiXin, isApp } from "@/packages/utils/"

import infoConf from "@/configs/info.conf"
import share from "@/packages/utils/share.js"
import linkedme from "@/packages/utils/linkedme.js"

import NativeShare from "nativeshare"

// const debug = process.env.NODE_ENV !== 'production'
// const _isWX = debug ? true : isWeiXin()
const _isWX = isWeiXin()
const _isApp = isApp()

var nativeShare = new NativeShare({
    syncDescToTag: true,
    syncIconToTag: true,
    syncTitleToTag: true
})

var _isLoadWXSdk = false,
    _isLoadLinkme = false

export default function() {
    return {
        async beforeMount() {
            if (!isApp()) { this.$$initLoadLinkme() }
            if (_isWX) {
                await this.$$initWechatSdk({ isWX: _isWX })
                share.share(infoConf.shareInfo)
            } else {
                nativeShare.setShareData(infoConf.shareInfo)
            }
        },
        methods: {
            $$initnNativeShare() {},
            async $$initWechatSdk(opts) {
                opts = { isWX: isWeiXin(), ...opts }
                if (!opts.isWX) return
                if (!_isLoadWXSdk) {
                    const isLoad = await script("http://res.wx.qq.com/open/js/jweixin-1.2.0.js")
                    _isLoadWXSdk = !!isLoad
                }
            },
            async $$initLoadLinkme() {
                if (!_isLoadLinkme) {
                    const isLoad = await script("http://static.lkme.cc/linkedme.min.js")
                    _isLoadLinkme = !!isLoad
                    if (_isLoadLinkme) linkedme.init()
                }
            },
            $$setShareInfo(info, cb) {
                _isWX
                    ? share.share({ ...infoConf.shareInfo, ...info }, { onShared: cb })
                    : nativeShare.setShareData({
                          ...infoConf.shareInfo,
                          ...info,
                          from: "@infzmwap"
                      })
            },
            $$getLinkmeUrl(data) {
                return _isLoadLinkme ? linkedme.create(data) : ""
            },
        }
    }
}
